import React from 'react';
import styled from 'styled-components';
import colors from './mot-colors.json';

const Bar = (props) => {
  const ratio = Math.abs(props.value) / props.maxValue;
  return (
    <div className={ props.className } style={{ position: 'relative', width: '100%' }}>
      <div className="fill"
           style={{
            width: (ratio * 100) + '%',
            position: 'absolute',
            left: '0px',
            top: '0px',
            bottom: '0px'
      }}>
      </div>
      <div className="text" style={{position: 'relative'}}>
        <div className="key"
             style={{
              position: 'absolute',
              left: (ratio * 100) + '%'
             }}
        ><span style={{marginLeft: 3}}>{ props.valueKey }</span></div>
      </div>
      <div style={{clear:'both'}} />
    </div>
  );
};

const StyledBar = styled(Bar)`
  height: 16px;
  font-family: Helvetica, sans-serif;
  margin-bottom: 1px;
  user-select: none;
  cursor: pointer;
  font-size: 14px;
  

  .fill {
    background: ${ props => props.background ? props.background : colors.cyan };
  }

  &:hover .fill {
    background: ${ props => props.hoverBackground ? props.hoverBackground : colors.red };
  }
`;

export default StyledBar;


// WEBPACK FOOTER //
// ./src/Bar.jsx